  export class AuthSessionModel {
    constructor(
      public id:string,
      public identity:string,
      public upn:string,
      public status:string,
      public authenticators:string,
      public authenticatorsDetails:Array<SessionAuthenticatorDetails>,
      public authenticationResult:string,
      public ubaMotionDetails:SessionUbaDetails,
      public ubaContextDetails:SessionUbaDetails,
      public application:string,
      public serviceFriendlyName:string,
      public authenticationDeviceName:string,
      public exploiterDeviceName:string,
      public httpContextIp:string,
      public location:any,
      public locationSource: string,
      public requestTime:Date,
      public authenticationTime:Date,
      public exploiterCtx:SessionDeviceCtx,
      public authCtx:SessionDeviceCtx,
      public transactionCode:string,
      public journeyId: string,
      public journeyDefinitionId: string,
      public identityId: string,
      public authenticationMode: string,
      public raw: string
    ) {}
  }

  export class SessionAuthenticatorDetails {
  constructor(
    public type:string,
    public status:boolean,
    public retries:number
  ) {}
  }

  export class SessionUbaDetails {
  constructor(
    public score: number,
    public answer: number,
    public answerConfidence: string,
    public scoreReason: any,
    public criteriaMet: any,
    public errorMessage
  ) {}
  }

  export class SessionDeviceCtx {
  constructor(
    public deviceMake:string,
    public deviceModel:string,
    public osName:string,
    public osVersion:string,
    public internetConnectionType:string,
    public userAgentName:string,
    public userAgentVersion:string,
    public ip: string
  ) {}
  }
